import styled from 'styled-components';
import { Wrapper } from '../shared/commonStyles';
import TitleSmall from '../title/TitleSmall';
import Description from '../text/Description';
import Logo from '../logo/Logo';
import '../styles/FadeInFromBottom.css'
import FadeInFromBottom from '../shared/FadeInFromBottom';

import brandStoryImage from '../../assets/image/brand_story/brand_story.png';

const BrandStoryWrapper = styled.section`
  .text-wrapper {
    width: 70%;
    margin: 0 auto;
  }
  
  .brand-story-wrapper {
    img {
      width: 100%;
      height: 100%;
    }
  }
`;

const SectionBrandStory = () => {
  const text = 'PLACOLE＆DRESSY(プラコレ＆ドレシー)\n『個性が煌めく魔法の言葉』\n“100人の人生に100通りに煌めく魔法をかける”を\nテーマに創設された古都鎌倉発の\nラグジュアリーブランド。';
  const text2 = 'ウェディングドレスを中心に\n最先端で価値あるものを発信する\nファッションメディアを運営。';
  const text3 = 'ドレスとお花がモチーフのオリジナルアイテムは、\nジュエリー、アクセサリー、食器、紅茶等、\n日常に少しでも煌めきを与えたい願いを込めて、\nウェディングドレスの伝統を重んじながら、\n常識をブレイクスルーする\n独創的なアイデアと最高級の品質で\n心を込めて制作しているブランドです。';

  return (
    <Wrapper id="brand-story">
      <BrandStoryWrapper>
        <TitleSmall title={"ブランドストーリー"} />
        {/* <FadeInFromBottom> */}
          <div className='brand-story-wrapper'>
            <img src={brandStoryImage} alt="ブランドストーリー" />
          </div>
        {/* </FadeInFromBottom> */}
        <Description text={text} />
        <Description text={text2} />
        <Description text={text3} />
        <Logo />
      </BrandStoryWrapper>
    </Wrapper>
  );
  };
  
export default SectionBrandStory;
  